/**
 * Supabase project identifiers for the browser client.
 *
 * `publicAnonKey` holds the PUBLISHABLE key (sb_publishable_*). It is public by
 * design — it ships in the client bundle and carries no privileges of its own;
 * every read and write it performs is still gated by RLS.
 *
 * It replaced the legacy `anon` JWT key on 2026-08-10. The legacy key had to go
 * because disabling the leaked legacy `service_role` key is a single project-wide
 * switch that disables legacy `anon` at the same time — see
 * docs/secret-rotation-runbook-2026-08-10.md.
 *
 * The name `publicAnonKey` is kept so the ~4 import sites stay untouched.
 */

export const projectId = "pdawphmepoiqugcviqpz"
export const publicAnonKey = "sb_publishable_u43W9Mv_s_GTbnc63l3HXA_6BCq7VHW"
